import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector   : 'glink-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls  : ['./confirm-dialog.component.scss']
})
export class GLinkConfirmDialogComponent
{
    public confirmMessage: string;

    /**
     * Constructor
     *
     * @param {MatDialogRef<GLinkConfirmDialogComponent>} dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<GLinkConfirmDialogComponent>
    )
    {
    }

}
